import {GoogleLogout} from "@leecheuk/react-google-login";
import PropTypes from "prop-types";

const clientId = process.env.REACT_APP_CLIENT_ID;

function Logout(props) {
    const onSuccess = (res) => {
        console.log("SUCCESS logout ", res)
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        props.handleLoggedOut()
    }

    const onFailure = (res) => {
        console.log(res)
    }

    return (
        <GoogleLogout
            onLogoutSuccess={onSuccess}
            onFailure={onFailure}
            clientId={clientId}
            buttonText="Log out"
        />
    )
}

Logout.propTypes = {
    handleLoggedOut: PropTypes.func
};

export default Logout